import { useState, useEffect } from 'react';

/**
 * 현재 화면이 모바일 크기인지 확인하는 Hook
 * @param {number} breakpoint - 모바일 판단 기준 (기본: 768px)
 * @returns {boolean} - 모바일 여부
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // 초기 체크
    checkIsMobile();

    // 리사이즈 이벤트 리스너
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
